import React, { useState, useEffect } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import TopSideCountBar from "./TopSideCountBar";
import DailyWeeklyReport from "./DailyWeeklyReport";
import TopLead from "./TopLead";
import MonthlyMembershipConversion from "./MonthlyMembershipConversion";
import MonthlyLeadConversion from "./MonthlyLeadConversion";

export default function SubAdminDashboard() {
   
    
   

    return (
        <div class="container body">
            <div class="main_container">
                <Sidebar />

                <Header />
                {/* page */}


                {/* page content */}
                <div className="right_col" role="main">
                    {/* top tiles */}
                    <div className="row">
                          <div className="col-xl-6">
                        
                        <h3>Welcome to Dashboard</h3>
                        </div>
                        <div className="col-xl-6">
                        </div>
                    

                    </div>


                </div>
                {/* /page content */}



                {/* page end */}
                <Footer />
            </div>
        </div>
    );
}